import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["label"]

  connect() {
    this.loadPreference()
  }

  toggle(event) {
    event.preventDefault()
    const isDark = document.body.classList.toggle("dark-mode")
    document.documentElement.classList.toggle("dark-mode")
    localStorage.setItem("dark-mode", isDark ? "true" : "false")
    document.cookie = `dark_mode=${isDark ? 'true' : 'false'}; path=/; max-age=31536000`
    this.updateLabel()
  }

  loadPreference() {
    const isDark = localStorage.getItem("dark-mode") === "true"
    if (isDark) {
      document.body.classList.add("dark-mode")
      document.documentElement.classList.add("dark-mode")
      document.cookie = `dark_mode=true; path=/; max-age=31536000`
    }
    this.updateLabel()
  }

  updateLabel() {
    const isDark = document.body.classList.contains("dark-mode")
    const darkModeText = this.element.dataset.darkModeText || "Dark Mode"
    const lightModeText = this.element.dataset.lightModeText || "Light Mode"
    this.element.innerHTML = isDark ? lightModeText : darkModeText
  }
}
